/**
 * Created by Jew on 7/24/2017.
 */
import { Component, Inject, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { IdexService } from 'app/idex.service';
import { Router } from '@angular/router';
import { Toast } from 'app/shared/toast/toast';
import { AddUserCompanyComponent } from 'app/admin/add-user-company/add-user-company.component';
import { AddGroupCompanyComponent } from 'app/admin/add-group-company/add-group-company.component';

@Component({
   selector: 'app-corporate-member',
   templateUrl: './member.component.html',
   styleUrls: ['./member.component.css']
})
export class CorporateMemberComponent implements OnInit {
   error: string;
   listMember: any;
   user_role: any;
   user: any;
   roles = [
      {value: 'Admin', viewValue: 'admin'},
      {value: 'Editor', viewValue: 'editor'},
      {value: 'Moderator', viewValue: 'moderator'},
      {value: 'Member', viewValue: 'member'}
   ];
   default_value = 'Member';
   private timer: any;
   searchFocused: boolean;
   searchResult: string[];
   searchSize = 8;
   email_value = '';
   tin_id: any;
   show = true;
   translate: any;
   type: boolean;
   private addmemberDialog: MatDialogRef<AddUserCompanyComponent>;
   isLoadingResults = true;
   isRateLimitReached = false;
   dataSource: MatTableDataSource<UserData>;
   resultsLength = 0;

   private addgroupDialog: MatDialogRef<AddGroupCompanyComponent>;
   users: UserGroupData[] = [];
   error_email = false;
   filterContactValue = '';
   listmembergroup: UserGroupData[] = [];
   displayedColumnsGroup = ['no', 'groupName', 'active'];
   dataSourceShare: MatTableDataSource<UserGroupData>;
   groups: UserGroupData[];
   siteName: any = '';

   searchList = [];
   isFindByCompany = false;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
      public service: IdexService, private router: Router, private toast: Toast, public dialog: MatDialog) {
      this.user = this.service.user;
   }
   ngOnInit() {
      this.getMember();
      this.getSiteName();

   }

   getSiteName() {
      const item = this.user.business.find(items => items.tin === this.tin_id);
      if (item !== undefined) {
         this.siteName = item.name;
      }

   }

   getMember() {
      this.service.get('/work/' + this.tin_id + '/memberships')
         .subscribe(
            data => {
               this.listMember = data;
               this.protectLast(this.listMember);
            }
         );
   }

   protectLast(item: any) {
      let j = 0;
      for (let i = 0; i < item.length; i++) {
         if (item[i].role === 'Admin') { j++; }
      }
      if (j === 1) { this.show = false; } else { this.show = true; }
   }

   cultivoChange(item: any) {
      const u = item.type === 'USER' ? 'true' : 'false';
      this.service.put('/work/' + this.tin_id + '/team/' + item.id + '/' + item.role + '?u=' + u, {})
         .subscribe(() => {
            if (item.role !== 'Member' && item.role !== 'Moderator') {
               this.updatePermPrint(item, false);
            }

            if (item.type === 'USER') {
               this.protectLast(this.listMember);
            } else {
               this.getMember();
            }
         });
   }

   search(q: string) {
      let results = this.searchList.filter(o => o.name.toLowerCase().includes(q.trim().toLowerCase()));
      return results.slice(0,this.searchSize);
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         if (!this.isFindByCompany) {
            this.service.get('/work/' + this.tin_id + '/users?filter=' + encodeURIComponent(input.value))
               .subscribe(
                  data => {
                     if (this.timer == null) {
                        if (data && data.length > 0) {
                           this.searchResult = data.slice(0,this.searchSize);
                        } else {
                           this.searchResult = [];
                        }
                     }
                  });
         } else {
            let data = this.search(input.value)
            if (this.timer == null) {
               if (data && data.length > 0) {
                  this.searchResult = data.slice(0,this.searchSize);
               } else {
                  this.searchResult = [];
               }
            }
         }

      }, 300);
   }
   onSearchFocus() {
      this.searchFocused = true;
   }
   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }
   selectSearchItem(item: any) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.email_value = item.id;
      this.type = item.type === 'USER';
   }
   addMember(input: any, option: any) {
      if (input.value.length === 0) {
         input.focus();
         return;
      }
      if (/[<|>\\\/:?*"]/g.test(input.value)) {
         this.translate.get('alert.create_folder_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      } else {
         for (let i = 0; i < this.listMember.length; i++) {
            if (this.listMember[i].id === input.value) {
               this.translate.get('alert.duplicate_username').subscribe(s => { this.toast.error(s); });
               return;
            }
         }
         this.type = this.type === undefined ? !input.value.startsWith('GROUP_') : this.type;
         this.service.post('/work/' + this.tin_id + '/team/' + input.value + '/' + option.selected.value + '?u=' + this.type, {})
            .subscribe(
               data => {
                  this.getMember();
                  this.email_value = '';
                  this.searchResult = null;
                  this.type = undefined;
               }
            );
      }
   }
   deleteMember(userName: any) {
      this.service.delete('/work/' + this.tin_id + '/' + userName.id + '/remove')
         .subscribe(
            data => {
               this.updatePermPrint(userName, false);
               if (userName.id === this.user.email) {
                  this.data.memberDialog.close();
                  this.translate.get('alert.remove_member').subscribe(s => {
                     this.toast.success(userName.id + s);
                  });
                  for (let i = 0; i < this.user.business.length; i++) {
                     if (this.user.business[i].tin === this.tin_id) {
                        const item = this.user.business[i];
                        const j = this.user.business.indexOf(item);
                        if (j !== -1) { this.user.business.splice(j, 1); }
                     }
                  }
                  this.router.navigate(['/files']);
               } else {
                  if (userName.type === 'USER') {
                     const i = this.listMember.indexOf(userName);
                     if (i !== -1) {
                        this.listMember.splice(i, 1);
                     }
                  } else {
                     this.getMember();
                  }
               }
            });
   }

   openContractDialogUser() {
      const data = {
         isEdit: false,
         username: undefined
      };
      this.addmemberDialog = this.dialog.open(AddUserCompanyComponent, {
         disableClose: true,
         width: '800px',
         data: data
      });
      this.addmemberDialog.componentInstance.tin = this.tin_id;
      this.addmemberDialog.afterClosed().subscribe(result => {
         if (result) {
            this.getMember();
         }
      });
   }
   openContractDialogGroup() {

      this.addgroupDialog = this.dialog.open(AddGroupCompanyComponent, {
         disableClose: true,
         width: '450px'
      });
      this.addgroupDialog.componentInstance.permission = 'Member';
      this.addgroupDialog.componentInstance.groupNameValue = '';
      this.addgroupDialog.componentInstance.tin = this.tin_id;
      this.addgroupDialog.componentInstance.members = [];
      this.addgroupDialog.componentInstance.isAddGroup = true;
      this.addgroupDialog.componentInstance.siteName = this.siteName;

      this.addgroupDialog.afterClosed().subscribe(result => {
         if (result) {
            this.getMember();
         }
      });
   }
   updatePermPrint(item: any, active: any) {
      let memberName = item.id;
      let memberType = 'Group';
      if (item.type === 'USER') {
         memberName = memberName.toLowerCase();
         memberType = 'User';
      } else {
         memberName = memberName.replace('GROUP_', '');
      }
      this.service.updatePermissionPrint(this.tin_id, memberName, memberType, active).subscribe((response) => {});
   }
}

export interface ContactsData {
   items: UserData[];
   totalCount: number;
   pageIndex: number;
}

export interface UserData {
   name: string;
   id: string;
   role: string;
}

export interface ContactsGroupData {
   items: UserGroupData[];
   totalCount: number;
   pageIndex: number;
}

export interface UserGroupData {
   name: string;
   id: string;
   role: string;
   type: string;
}

export interface GroupData {
   name: string;
   id: string;
}
